import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { subscribeEmail } from "../service/auth";
import { isValidEmail } from "../helpers/globals";
import { handleAuthSuccessRedirect } from "../utils/authRedirect";
import "./EmailSignupForm.css";

function EmailSignupForm() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { handleSuccessfulSignup } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // Validate email
    if (!email.trim()) {
      setError("Please enter your email address");
      return;
    }

    if (!isValidEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setIsLoading(true);

    try {
      // Sign up with email
      const response = await subscribeEmail({
        email: email.trim(),
        newsletter_on: true,
        zebra_id: "PartyParty-Free-Trial-Mar26",
      });

      // Store auth token and user data
      if (response.data && response.data.token) {
        // Update auth state immediately
        handleSuccessfulSignup(response.data.token, response.data.data);

        localStorage.setItem("hasCreatedAccount", "true");

        handleAuthSuccessRedirect(navigate, location);
      } else {
        throw new Error("Invalid response from signup API");
      }
    } catch (err) {
      console.error("Email signup error:", err);
      setError(
        err.response?.data?.message ||
        err.message ||
        "Failed to sign up. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form className="email-signup-form" onSubmit={handleSubmit}>
      <input
        type="email"
        className="email-signup-input"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        disabled={isLoading}
        autoComplete="email"
      />
      <button
        type="submit"
        className="email-signup-button"
        disabled={isLoading}
      >
        {isLoading ? "Signing up..." : "Continue with email"}
      </button>
      {error && <div className="email-signup-error">{error}</div>}
    </form>
  );
}

export default EmailSignupForm;
